import { Box, IconButton, Popover, Typography } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import Help from '@material-ui/icons/Help'
import HelpOutline from '@material-ui/icons/HelpOutline'
import { useState } from 'react'

import { useStyles } from './styles'

export function StatusHelperModal() {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  function handleClose() {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        color='inherit'
        size='small'
        className={classes.button}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        aria-label='Ajuda com status das atividades'
      >
        <HelpOutline color='inherit' fontSize='small' />
        <Help color='inherit' fontSize='small' />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        elevation={3}
      >
        <div className={classes.header}>
          <Typography variant='h3'>Status das atividades</Typography>
          <IconButton
            size='small'
            color='inherit'
            aria-label='fechar'
            onClick={handleClose}
          >
            <Close />
          </IconButton>
        </div>
        <div className={classes.content}>
          <ul>
            <Typography component={'li'}>
              <Box bgcolor='#C6C7C2' borderColor='#727970' />
              Atividades concluídas.
            </Typography>
            <Typography component={'li'}>
              <Box bgcolor='#A5C5D7' borderColor='#55AFCB' />
              Atividades agendadas ou em processamento.
            </Typography>
            <Typography component={'li'}>
              <Box bgcolor='#FFDAD4' borderColor='#BA1B1B' />
              Atividades atrasadas.
            </Typography>
          </ul>
        </div>
      </Popover>
    </>
  )
}
